import common from './common';

import sentry from './sentry';

const services = { common, sentry };

export default services;
